module.exports = __webpack_public_path__ + "static/media/zombie.f8cd3252.jpg";